import React, { useRef } from 'react';
import styled from 'styled-components';
import PopUp from '../PopUp/PopUp';
import TitleWithInfo from '../TitleWithInfo/TitleWithInfo';
import { useState } from 'react';
import { formatNumber } from '../TendsInUserActivity/LineChart';
import { useDispatch } from 'react-redux';
import DrillThroughFilterMenu from '../DrillThroughFilterMenu/DrillThroughFilterMenu';
import { setFilterPanel } from '../../store/redux/slices/filterPanelSlice';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: ${(props) => props.maxWidth};
  padding: ${(props) => (props?.padding ? props?.padding : '10px')};
  box-sizing: border-box;
  font-family: Open Sans;
`;
const EachRow = styled.div`
  display: grid;
  grid-template-columns: 20% 1fr;
  align-items: center;
  justify-items: center;
  gap: 10px;
`;

const Star = styled.div`
  font-size: 14px; /* Adjust font size */
  color: #636363;
  text-align: end;
  width: 100%;
  font-family: Montserrat;
  word-break: break-all;
  font-family: 'Inter';
`;

const PercentageBar = styled.div`
  display: flex;
  border-radius: 2px;
  background: ${(props) => props.color};

  width: ${(props) => props.width};
  height: 30px;
  padding: 5px 25px;
  justify-content: center;
  box-sizing: border-box;

  font-family: 'Inter';
  color: #000;
  font-weight: 400;
  position: relative;

  ${(props) => {
    if (parseInt(props.actualWidth) < 0) {
      return `&:after {
            content:'${props.actualWidth}${props.type}';
            position: absolute;
            left:110%;
            color:#222;
          }`;
    }
  }}
`;

const NoDataWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 20% 1fr min-content;
  gap: 2%;
  padding-top: 5px;
  box-sizing: border-box;

  color: #636363;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;

  min-height: 215px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextWrapper = styled.div`
  // text-align: left;
  // overflow:scroll !important;
  & > * {
    // float: left;
    clear: both;
    margin-bottom: 10px;
    padding: 5px 10px;
  }

  span {
    font: Open Sans;
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 25px;
  }
`;
const Message = styled.div`
  color: #2a2929;
  text-align: left;
  font-family: 'Open Sans';
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 90px;
  overflow: scroll;
  padding-bottom: 0px !important;
  margin-bottom: 0px;
`;
const StatusValWrapper = styled.div`
  text-align: justify;
  display: flex;
  align-items: center;

  & :first-child {
    height: 12px;
    width: 12px;
    content: ' ';
    display: grid;
    background: ${(props) =>
      props?.summaryVal?.fill ? props?.summaryVal?.fill : ''};
    border-radius: 50%;
    margin-bottom: 0px;
  }

  & :nth-child(2) {
    font-size: 15px;
    font-weight: 400;
    color: black;
    margin-left: 5px;
    margin-bottom: 0px;
  }
`;
const CancelButton = styled.span`
  cursor: pointer;
  float: right;
  margin: 20px 20px 0px 0px;

  color: #000;
  text-align: center;
  font-family: 'Open Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const FunnelGraph = ({
  data,
  maxWidth = '100%',
  type = '',
  summary = {},
  title = '',
  showFormatted = false,
  handleTabClick,
  drillThroughType,
  showDrillThrough = true,
  isChatter,
  sorted=false,
  verified = false,
}) => {
  const [summaryVal, setSummaryVal] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  let finalData = data
    .filter((el) => el.value > 0)
    .map((e1) => {
      return {
        name: e1.name,
        value: parseFloat(e1.value),
        fill: e1.fill,
      };
    })
    
    var sortedData = [];
    
    if(sorted == false){
      sortedData =  finalData.sort((a, b) => b.value - a.value);
    }else{
      let baseColors = [];
      if (verified) {
        baseColors = [
          'rgba(45, 137, 85, 1)', // Darkest
          'rgba(45, 137, 85, 0.5)',
        ];
      } else {
        baseColors = [
          'rgba(45, 137, 85, 1)', // Darkest
          'rgba(45, 137, 85, 0.8)',
          'rgba(45, 137, 85, 0.6)',
          'rgba(45, 137, 85, 0.4)', // Lightest
          'rgba(45, 137, 85, 0.2)', // Lightest
        ];
      }
      sortedData = [...data]
        .sort((a, b) => b.value - a.value)
        .map((item, index) => ({
          ...item,
          fill: baseColors[index],
        }));
    };

  const maxValue = Math.max(...sortedData.map((item) => item.value));
  const multiplier = 100 / maxValue;

  const tooltipFormatter = (value) => {
    return ` ${typeof value === 'number' && value !== 0 && value}`;
  };

  const handleOpenSummary = (rating) => {
    if (rating.value > 0 && title == 'Emotional_Analysis') {
      setSummaryVal(rating);
      setShowPopup(true);
    }
  };
  const dispatch = useDispatch();
  const [rightClickedBar, setRightClickedBar] = useState(null);
  const [showRightClickPopup, setShowRightClickPopup] = useState(false);
  const [rightClickPosition, setRightClickPosition] = useState({
    top: 0,
    left: 0,
  });
  const barContainerRef = useRef(null);
  const handleBarRightClick = (event, barData) => {
    event.preventDefault();

    if (barContainerRef.current) {
      const rect = barContainerRef.current.getBoundingClientRect();
      const top = event.clientY - rect.top;
      const left = event.clientX - rect.left;

      setRightClickPosition({ top, left });
    }

    setRightClickedBar(barData);
    setShowRightClickPopup(true);
  };
  const popupRef = useRef(null);
  const handleDrillThrough = (data) => {
    var filterPanel = {};
    if (
      data?.name === 'Male' ||
      data?.name === 'Female' ||
      data?.name === 'Unknown'
    ) {
      filterPanel = {
        gender: [data?.name?.toLowerCase()],
      };
    }
    if (data?.name === 'Non Verified' || data?.name === 'Verified') {
      filterPanel = {
        user_type: [data?.name === 'Verified' ? 'True' : 'False'],
      };
    }
    if (drillThroughType === 'posts') {
      filterPanel = {
        search: [{ type: 'post', value: data?.name }],
      };
    }
    if (drillThroughType === 'account') {
      filterPanel = {
        search: [{ type: 'profile', value: data?.name }],
      };
    }
    if (drillThroughType === 'sentiment') {
      filterPanel = {
        sentiment: [
          data?.name === 'Positive' ? 1 : data?.name === 'Negative' ? -1 : 0,
        ],
      };
    }
    if (drillThroughType === 'emotion') {
      filterPanel = {
        emotion: [data?.name?.toLowerCase()],
      };
    }
    if (drillThroughType === 'review') {
      filterPanel = {
        rating: [data?.name?.slice(0, 1)],
      };
    }
    dispatch(setFilterPanel(filterPanel));

    setShowRightClickPopup(false);
    isChatter === true
      ? handleTabClick('commentsTab')
      : handleTabClick('reviewsTab');
  };
  return (
    <Wrapper
      padding={sortedData && sortedData.length > 0 ? '10px' : '0'}
      maxWidth={sortedData && sortedData.length > 0 ? maxWidth : 100}
      className='pdf-page'
      ref={barContainerRef}
      style={{ pageBreakInside: 'avoid', position: 'relative' }}
    >
      {sortedData && sortedData?.length ? (
        sortedData.map((value, name) => (
          <EachRow key={name} onClick={() => handleOpenSummary(value)}>
            <Star>{value.name}</Star>
            <PercentageBar
              width={Math.floor(value.value * multiplier) + '%'}
              actualWidth={value.value}
              type={type}
              color={value.fill || '#353cf7'}
              onContextMenu={(e) => {
                if (showDrillThrough === true) {
                  handleBarRightClick(e, value);
                }
              }}
            >
              {showFormatted
                ? value.value > 0 &&
                  formatNumber(tooltipFormatter(value.value)) + type
                : value.value > 0 && tooltipFormatter(value.value) + type}
            </PercentageBar>
          </EachRow>
        ))
      ) : (
        <NoDataWrapper>
          {/* No Data Available */}Insufficient Data
        </NoDataWrapper>
      )}
      {showPopup &&
        summary[summaryVal?.name && summaryVal?.name?.toLowerCase()] && (
          <PopUp
            minWidth={'700px'}
            height={'280px'}
            maxWidth={'700px'}
            onClose={() => setShowPopup(false)}
          >
            {/* <span>cross</span>
          <div>{reviews[reviewMessage]}</div> */}
            <TextWrapper>
              <div>
                <TitleWithInfo title={'Summary '} infoText={``} />
              </div>
              <br />
              <Message>
                {summary[summaryVal?.name && summaryVal?.name?.toLowerCase()]}
              </Message>
              <br />
              <StatusValWrapper summaryVal={summaryVal}>
                <span></span>{' '}
                <span>{`${summaryVal?.name}- ${
                  summaryVal?.value ? summaryVal?.value : 0
                }%`}</span>
              </StatusValWrapper>
              <CancelButton onClick={() => setShowPopup(false)}>
                Close
              </CancelButton>
            </TextWrapper>
          </PopUp>
        )}
      {showRightClickPopup && rightClickedBar && (
        <div
          style={{
            position: 'absolute',
            top: `${rightClickPosition.top}px`,
            left: `${rightClickPosition.left}px`,
            zIndex: 9999,
            background: 'white',
            borderRadius: '6px',
          }}
          ref={popupRef}
        >
          <DrillThroughFilterMenu
            handleDrillThrough={() =>
              handleDrillThrough({
                name: rightClickedBar?.name,
                value: rightClickedBar?.value,
              })
            }
          />
        </div>
      )}
    </Wrapper>
  );
};

export default FunnelGraph;
